import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { businessList as businessListFbu } from '@/api/gucangSales/chanceManage'
import { businessList as businessListOfbu } from '@/api/overseasSales/chanceManage'
import BusinessName from '@/components/BusinessName/index.vue'
import type { PropType } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'businessSelect',
  props: {
  value: {
    type: [Number, String, Array]
  },
  arkCodeId: {
    // arkCode必填
    type: [Number, String]
  },
  saleChanceRefId: {
    // arkCode必填
    type: String
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  statusList: {
    type: Array as PropType<number[]>
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props
const data = ref()
const emit = __emit
const optionPage = ref<any[]>([])
// 获取商机下拉列表
const businessListMethod = {
  cos_fbu: businessListFbu,
  cos_ofbu: businessListOfbu
}
const fetch = () => {
  if (props.arkCodeId) {
    businessListMethod[props.appId]({
      arkCodeId: props.arkCodeId,
      pageNumber: 1,
      pageSize: 500,
      statusList: props.statusList
    }).then((res: any) => {
      optionPage.value = res.data.items
    })
  }
}
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v !== prev && v !== data.value) {
      data.value = v
    }
  },
  { immediate: true }
)
watch(
  () => props.arkCodeId,
  (v, prev) => {
    if (v && v !== prev) {
      fetch()
      if (prev) {
        emit('update:value', undefined)
      }
    } else if (!v) {
      emit('update:value', undefined)
      optionPage.value = []
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  emit('update:value', value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
    style: {"width":"100%"},
    showSearch: true,
    "filter-option": false,
    placeholder: _ctx.$t('common.pleaseSelect'),
    onChange: change
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPage.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.id,
          value: item.id
        }, {
          default: _withCtx(() => [
            _createVNode(BusinessName, {
              appId: __props.appId,
              value: item.saleChanceName,
              "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
            }, null, 8, ["appId", "value", "onUpdate:value"])
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "placeholder"]))
}
}

})